import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import InfluencerInitializer from '../../Components/InfluencerInitializer/InfluencerInitializer';
import InviteTokenAPI from '../../Lib/Api/invite-token';
import { actions as socialMediaActions } from '../SocialMedia/slice';
import {
  influencersCountSelector,
  influencersLoadingSelector,
  influencersSelector,
} from '../SocialMedia/selectors';

const mapStateToProps = (state) => ({
  influencers: influencersSelector(state),
  influencersCount: influencersCountSelector(state),
  influencersLoading: influencersLoadingSelector(state),
});
const mapDispatchToProps = (dispatch) => ({
  getInfluencers: (params) =>
    dispatch(socialMediaActions.getInfluencers({ params })),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )((props) => (
    <InfluencerInitializer {...props} sendForm={InviteTokenAPI.create} />
  )),
);
